import commaDecimalToDecimal from "@/app/infrastructures/misc/common-library/CommaDecimalToDecimal";

const parseInputFloatToFloat = (value: any) => {
  return Number(commaDecimalToDecimal(value.replace(/\./g, "")));
};

export default parseInputFloatToFloat;